var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTodolist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#056363;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.544,2.411a.568.568,0,0,0-.8,0L2.762,5.342,1.7,4.318a.568.568,0,0,0-.8,0l-.736.728a.551.551,0,0,0,0,.787L2.4,8.027a.6.6,0,0,0,.825,0L3.953,7.3,7.337,3.962a.555.555,0,0,0,0-.787Zm0,7.369a.568.568,0,0,0-.8,0l-2.985,2.95L1.7,11.707a.568.568,0,0,0-.8,0l-.736.726a.551.551,0,0,0,0,.787l2.225,2.2a.6.6,0,0,0,.825,0l.736-.726L7.336,11.35a.551.551,0,0,0,0-.782ZM3,17.8a2.223,2.223,0,1,0,0,4.444A2.222,2.222,0,1,0,3,17.8Zm20.25.741H9.75a.745.745,0,0,0-.75.741v1.481a.745.745,0,0,0,.75.741h13.5a.745.745,0,0,0,.75-.741V19.285A.745.745,0,0,0,23.25,18.544Zm0-14.814H9.75A.745.745,0,0,0,9,4.471V5.953a.745.745,0,0,0,.75.741h13.5A.745.745,0,0,0,24,5.953V4.471A.745.745,0,0,0,23.25,3.731Zm0,7.407H9.75a.745.745,0,0,0-.75.741V13.36a.745.745,0,0,0,.75.741h13.5A.745.745,0,0,0,24,13.36V11.878A.745.745,0,0,0,23.25,11.138Z",
    transform: "translate(0 -2.248)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodolist);
export default __webpack_public_path__ + "static/media/todolist.2cbe5c39652671830458ec3af8ae2080.svg";
export { ForwardRef as ReactComponent };